import * as S from './styles';
import CenterImage from './assets/center.png';
import { CoinSelector } from './CoinSelector';
import { LeverageTable } from './LeverageTable';
import { LeverageTableSkeleton } from './Skeleton';
import Faq from './Faq';
import useGetCoinTier from '@/app/hooks/trade/coinTier';
import { useMemo, useState } from 'react';
import { useExchangeStore } from '@/app/hooks/trade/exchangeStore';
import type { CoinDetail, CoinTier } from './types';
import { useTranslation } from 'react-i18next';

export const MMRPage = () => {
  const { t } = useTranslation();
  const [symbol, setSymbol] = useState('BTC');

  const { getCoinTiersByBase } = useGetCoinTier();
  const { EPs } = useExchangeStore();

  const coinDetail = useMemo<CoinDetail | undefined>(
    () => EPs?.find((item: any) => item.symbol === symbol),
    [EPs, symbol]
  );

  const coinTiers = useMemo<CoinTier[]>(
    () => getCoinTiersByBase(symbol),
    [symbol]
  );

  return (
    <S.Wrapper>
      <S.Container>
        <S.Header>
          <S.Title>
            <span>{t('leverageMarginTitle.leverage')}</span>
            <span>&</span>
            <span className="highlight">{t('leverageMarginTitle.margin')}</span>
          </S.Title>
          <S.CenterImage src={CenterImage} alt="center-image" />
        </S.Header>

        <S.Content>
          <S.ContentTop>
            <CoinSelector
              coinDetail={coinDetail}
              coinList={EPs}
              onSelectCoin={setSymbol}
            />
            {coinTiers.length > 0 ? (
              <LeverageTable coinTiers={coinTiers} />
            ) : (
              <LeverageTableSkeleton />
            )}
          </S.ContentTop>
        </S.Content>

        <Faq />
      </S.Container>
    </S.Wrapper>
  );
};
